/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Orders
 * Use the Orders Selling Partner API to programmatically retrieve order information. With this API, you can develop fast, flexible, and custom applications to manage order synchronization, perform order research, and create demand-based decision support tools.   _Note:_ For the JP, AU, and SG marketplaces, the Orders API supports orders from 2016 onward. For all other marketplaces, the Orders API supports orders for the last two years (orders older than this don\'t show up in the response).
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Measurement information for an order item.
 */
export interface Measurement {
    /**
     * The unit of measure.
     */
    'Unit': MeasurementUnitEnum;
    /**
     * The measurement value.
     */
    'Value': number;
}

export const MeasurementUnitEnum = {
    Ounces: 'OUNCES',
    Pounds: 'POUNDS',
    Kilograms: 'KILOGRAMS',
    Grams: 'GRAMS',
    Milligrams: 'MILLIGRAMS',
    Inches: 'INCHES',
    Feet: 'FEET',
    Meters: 'METERS',
    Centimeters: 'CENTIMETERS',
    Millimeters: 'MILLIMETERS',
    SquareMeters: 'SQUARE_METERS',
    SquareCentimeters: 'SQUARE_CENTIMETERS',
    SquareFeet: 'SQUARE_FEET',
    SquareInches: 'SQUARE_INCHES',
    Gallons: 'GALLONS',
    Pints: 'PINTS',
    Quarts: 'QUARTS',
    FluidOunces: 'FLUID_OUNCES',
    Liters: 'LITERS',
    CubicMeters: 'CUBIC_METERS',
    CubicFeet: 'CUBIC_FEET',
    CubicInches: 'CUBIC_INCHES',
    CubicCentimeters: 'CUBIC_CENTIMETERS',
    Count: 'COUNT',
} as const;

export type MeasurementUnitEnum = typeof MeasurementUnitEnum[keyof typeof MeasurementUnitEnum];


